\:host
    width: 100%

.Divider
    width: 100%
    height: 30px
    margin: 0
    padding: 0
    display: flex
    align-items: center
    clear: both
    box-sizing: border-box

.Line
    width: 100%
    height: 1px
    background-color: rgb($globalSettingsStrokeTertiary)
    box-sizing: border-box
